"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkWRBN6DWMjs = require('./chunk-WRBN6DWM.js');

// src/checksum.ts
var _superstruct = require('superstruct');
var ChecksumStruct = _superstruct.size.call(void 0, 
  _chunkWRBN6DWMjs.base64.call(void 0, _superstruct.string.call(void 0, ), { paddingRequired: true }),
  44,
  44
);



exports.ChecksumStruct = ChecksumStruct;
//# sourceMappingURL=chunk-XYYGZF5Y.js.map